//lunr go

var search_all_input = $('.search-full-text-form__input')
function searchAll() {
	var search_all = $('.search-full-text-form__input').val()
	localStorage.setItem("search_all", search_all);
}

$('.search-full-text-form__input').on('keydown', function(e) {
  keycode = e.which
  onSearchAll(keycode)
})

function onSearchAll(keycode) {
  if (keycode === 13){
    console.log('enter')
    searchAll()
    window.location = '/bb/h1/fy'+ yr +'h1/search_results.html'
  } //enter
}



if (navigator.userAgent.toString().search('Mobi') > -1) {
	$.when(
		$.getJSON(path + '/mobile_index.json'),
		$.getJSON(path + '/full_text_search.json')
	).done(function(index, full_text) {
		success: callback_full(index, full_text)
	});
} else {
	$.when(
		$.getJSON(path + '/index.json'),
		$.getJSON(path + '/full_text_search.json')
	).done(function(index, full_text) {
		success: callback_full(index, full_text)
	});
}
